var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-tips"},[_vm._v("\n  暂未上线，敬请期待~")])}
var staticRenderFns = []

export { render, staticRenderFns }